import React from 'react'

export function ClipIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      fill="none"
      viewBox="0 0 22 20"
    >
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M14.644.837a6.225 6.225 0 014.665 1.854 6.225 6.225 0 011.854 4.665c-.05 1.527-.637 2.957-1.5 3.82l-7.072 7.072-.53-.53-.53-.53 7.07-7.072c.551-.55 1.024-1.595 1.063-2.808a4.726 4.726 0 00-1.416-3.556 4.726 4.726 0 00-3.556-1.416c-1.213.04-2.258.512-2.808 1.063l-9.546 9.545c-.22.222-.594.85-.667 1.66-.07.765.128 1.69 1.02 2.583.894.893 1.819 1.09 2.584 1.021.81-.074 1.438-.446 1.66-.667l9.192-9.193c.2-.2.41-.633.445-1.154.033-.503-.103-.978-.445-1.32-.342-.343-.818-.479-1.32-.445-.521.034-.956.245-1.155.444l-6.717 6.718-.53-.53-.531-.53 6.717-6.718c.508-.508 1.311-.827 2.116-.881.823-.055 1.762.162 2.48.88m0 4.597c.508-.507.828-1.31.881-2.116.055-.823-.162-1.762-.88-2.48m0 4.596l-9.193 9.192c-.486.486-1.449.998-2.584 1.1-1.179.108-2.552-.225-3.78-1.453C.403 17.019.07 15.647.177 14.468c.103-1.135.614-2.098 1.1-2.584l9.546-9.546c.864-.864 2.294-1.452 3.821-1.501m-8.24 11.224l-.53-.53a.75.75 0 101.06 1.06l-.53-.53zm5.127 6.187a.75.75 0 010-1.06l.53.53.53.53a.75.75 0 01-1.06 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}
